import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormFieldComponent } from './form-field.component';
import { FormControlModule } from '../form-control/form-control.module';

@NgModule({
  id: 'form-field',
  imports: [
    CommonModule,
    FormControlModule,
  ],
  declarations: [
    FormFieldComponent,
  ],
  exports: [
    FormFieldComponent,
  ],
  providers: [],
})

export class FormFieldModule {
}
